import React from "react";
import { useTranslation } from "react-i18next";

const Bio = () => {
  const { t } = useTranslation();

  return (
    <section className="bio-container" id="bio" aria-labelledby="bio-title">
      <div>
        <p className="subtitle">{t("bio.subtitle")}</p>
        <h3>{t("bio.title")}</h3>
        <p>{t("bio.description1")}</p>
      </div>
      <div className="bio-image">
        <img src="/images/about.jpg" 
        alt="Portrait of Farzad Cheshk, Consultant and Entrepreneur" 
        className="bio-image" />
      </div>
    </section>
  );
};

export default Bio;
